import {ModalLayout} from "../../shared/modal-layout";
import {FontAwesome} from "@expo/vector-icons";
import {UpdateUserForm} from "./modal-user/update-user-form";
import * as React from "react";

export const ModalUser = ({
                              user,
                              closeModal,
                              onSubmit
                          }) => <ModalLayout title="Your information"
                                             icon={<FontAwesome name="user" size={24} color="#a0c946"/>}
                                             close={closeModal}>
    <UpdateUserForm user={user} onSubmit={async data => {
        await onSubmit(data);
        closeModal()
    }} submitLabel="Update" submitButtonAppearance="filled"/>
</ModalLayout>